/* src/app/_shared/components/checkbox/checkbox.component.scss */
:host {
  display: block;
  --checked-font-weight: bold;
  --checked-background-color: var(--ion-color-action);
  --disabled-border: var(--ion-color-medium);
  --disabled-color: var(--ion-color-medium);
  --disabled-background: var(--ion-color-medium);
}
:host.ng-invalid label {
  color: var(--ion-color-danger);
}
:host[disabled] .flow-checkbox label,
:host[disabled=true] .flow-checkbox label,
:host[ng-reflect-disabled=true] .flow-checkbox label {
  color: var(--disabled-color);
}
:host[disabled] .flow-checkbox .checkbox-container input:checked + .checkbox-control,
:host[disabled=true] .flow-checkbox .checkbox-container input:checked + .checkbox-control,
:host[ng-reflect-disabled=true] .flow-checkbox .checkbox-container input:checked + .checkbox-control {
  border-color: var(--disabled-border);
  background-color: var(--disabled-background);
}
.flow-checkbox label {
  display: flex;
  align-items: center;
  flex-flow: row nowrap;
  font-size: var(--input-font-size);
}
.flow-checkbox label.checked {
  font-weight: var(--checked-font-weight);
}
.flow-checkbox label .checkbox-container input {
  position: absolute;
  width: 1em;
  height: 1em;
  opacity: 0;
}
.flow-checkbox label .checkbox-container input:checked + .checkbox-control {
  border-color: var(--checked-background-color);
  background-color: var(--checked-background-color);
}
.flow-checkbox label .checkbox-container input:checked + .checkbox-control ion-icon {
  opacity: 1;
}
.flow-checkbox label .checkbox-container .checkbox-control {
  display: block;
  width: 1.3em;
  height: 1.3em;
  overflow: hidden;
  border: 1px solid var(--ion-color-medium);
  border-radius: 50%;
  transition: all 0.1s;
}
.flow-checkbox label .checkbox-container .checkbox-control ion-icon {
  opacity: 0;
  margin-top: 1px;
  margin-left: 1px;
  color: var(--ion-color-action-contrast);
  transition: all 0.1s;
}
.flow-checkbox label .checkbox-label {
  margin-top: -1px;
  margin-left: var(--space-left);
  font-size: 14px;
}
.flow-checkbox label .checkbox-container input:checked + .checkbox-label {
  font-weight: var(--checked-font-weight);
}
/*# sourceMappingURL=checkbox.component-5VU4LA22.css.map */
